// extracted by mini-css-extract-plugin
export var billingAddress = "_rn-g";
export var contactInfo = "_rn-d";
export var customerInfoContainer = "_rn-c";
export var customerInfoContainerMobile = "_rn-h";
export var customerInfoRow = "_rn-a";
export var customerInfoSection = "_rn-b";
export var fullWidthDividerMobile = "_rn-i";
export var imageContainer = "_rn-1";
export var paymentMethod = "_rn-e";
export var priceText = "_rn-6";
export var priceTextMobile = "_rn-7";
export var product = "_rn-0";
export var productImage = "_rn-2";
export var productInfo = "_rn-4";
export var productMobile = "_rn-9";
export var productTitle = "_rn-8";
export var quantityBadge = "_rn-3";
export var quantityText = "_rn-5";
export var shippingAddress = "_rn-f";